import React from 'react';
import PropTypes from 'prop-types';
import { LuCircleCheck, LuCircleX } from 'react-icons/lu';

const TONES = {
  idle: 'tw-border-slate-200 tw-bg-white/70 tw-text-slate-700 enabled:hover:tw-border-teal-400/60 enabled:hover:tw-bg-white dark:tw-border-white/10 dark:tw-bg-white/[0.03] dark:tw-text-slate-200 dark:enabled:hover:tw-bg-white/[0.06]',
  selected: 'tw-border-teal-500/60 tw-bg-teal-500/10 tw-text-teal-900 dark:tw-text-teal-100',
  correct: 'tw-border-emerald-500/60 tw-bg-emerald-500/10 tw-text-emerald-900 dark:tw-text-emerald-100',
  wrong: 'tw-border-rose-500/60 tw-bg-rose-500/10 tw-text-rose-900 dark:tw-text-rose-100',
};
const LETTER_TONES = {
  idle: 'tw-bg-slate-100 tw-text-slate-500 dark:tw-bg-white/[0.07] dark:tw-text-slate-300',
  selected: 'tw-bg-teal-500 tw-text-white',
  correct: 'tw-bg-emerald-500 tw-text-white',
  wrong: 'tw-bg-rose-500 tw-text-white',
};

/** One answer of a quiz question: letter, text and - after grading - right / wrong. */
const QuizChoice = ({ letter, state = 'idle', disabled, onClick, children }) => (
  <button
    type="button"
    role="radio"
    aria-checked={state === 'selected'}
    disabled={disabled}
    onClick={onClick}
    className={`tw-flex tw-w-full tw-items-center tw-gap-3 tw-rounded-2xl tw-border tw-px-3.5 tw-py-3 tw-text-left tw-text-sm tw-font-medium tw-transition-colors focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-teal-500/50 disabled:tw-cursor-default ${TONES[state]}`}
  >
    <span className={`tw-grid tw-h-8 tw-w-8 tw-shrink-0 tw-place-items-center tw-rounded-xl tw-text-xs tw-font-bold ${LETTER_TONES[state]}`}>{letter}</span>
    <span className="tw-min-w-0 tw-flex-1 tw-leading-snug">{children}</span>
    {state === 'correct' && <LuCircleCheck aria-hidden="true" className="tw-h-5 tw-w-5 tw-shrink-0 tw-text-emerald-500" />}
    {state === 'wrong' && <LuCircleX aria-hidden="true" className="tw-h-5 tw-w-5 tw-shrink-0 tw-text-rose-500" />}
  </button>
);

QuizChoice.propTypes = {
  letter: PropTypes.string.isRequired,
  state: PropTypes.oneOf(Object.keys(TONES)),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node,
};

export default QuizChoice;
